export default {
  call: 'getBusinessNumbersReporting',

  startdate: '2020-07-10',
  enddate: '2020-07-14',
  timezone: 'America/Los_Angeles',
};
